export const downloadMedia = (url, filename) => {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const href = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", "mediaFile-" + filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => {
      console.error("Error fetching the file for download:", error);
    });
};

export const isIframeWindow = () => window.self !== window.top;

const getUserSpecificKey = (key) => {
  let newKey = key;
  const currentUser = localStorage.getItem("currentUser");

  if (currentUser) {
    const user = JSON.parse(currentUser);
    if (user.email) {
      newKey = `${user.email}-${key}`;
    }
  }
  if (isIframeWindow() && window.name) {
    newKey = `${window.name}-${newKey}`;
  }
  return newKey;
};
export const getItemFromLocalStorage = (rawKey) => {
  const key = getUserSpecificKey(rawKey);

  let item = null;
  if (localStorage) {
    item = localStorage.getItem(key);
    if (typeof item !== "string") return item;
    if (item === "undefined") return undefined;
    if (item === "null") return null;
    // Check for numbers and floats
    if (/^'-?\d{1,}?\.?\d{1,}'$/.test(item)) return Number(item);
    // Check for serialized objects and arrays
    if (item[0] === "{" || item[0] === "[") return JSON.parse(item);
  }

  return item;
};
export const saveItemToLocalStorage = (rawKey, value) => {
  if (localStorage) {
    try {
      const key = getUserSpecificKey(rawKey);

      if (typeof key !== "string") {
        throw new TypeError(
          `localStorage: Key must be a string. (reading '${key}')`
        );
      }

      if (typeof value === "object") {
        value = JSON.stringify(value);
      }

      localStorage.setItem(key, value);
    } catch (e) {
      console.error("Error saving to local storage:", e.message);
    }
  }
};
export const getItemFromSessionStorage = (rawKey) => {
  const key = getUserSpecificKey(rawKey);

  let item = null;
  if (sessionStorage) {
    item = sessionStorage.getItem(key);
    if (typeof item !== "string") return item;
    if (item === "undefined") return undefined;
    if (item === "null") return null;
    // Check for numbers and floats
    if (/^'-?\d{1,}?\.?\d{1,}'$/.test(item)) return Number(item);
    // Check for serialized objects and arrays
    if (item[0] === "{" || item[0] === "[") return JSON.parse(item);
  }
  return item;
};
export const saveItemToSessionStorage = (rawKey, value) => {
  if (sessionStorage) {
    try {
      const key = getUserSpecificKey(rawKey);

      if (typeof key !== "string") {
        throw new TypeError(
          `localStorage: Key must be a string. (reading '${key}')`
        );
      }

      if (typeof value === "object") {
        value = JSON.stringify(value);
      }

      sessionStorage.setItem(key, value);
    } catch (e) {
      console.error("Error saving to local storage:", e.message);
    }
  }
};

export const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};
export const throttle = (fn, wait) => {
  let inThrottle, lastFn, lastTime;
  return function () {
    const context = this,
      args = arguments;
    if (!inThrottle) {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFn);
      lastFn = setTimeout(function () {
        if (Date.now() - lastTime >= wait) {
          fn.apply(context, args);
          lastTime = Date.now();
        }
      }, Math.max(wait - (Date.now() - lastTime), 0));
    }
  };
};

export const mergeAndDeduplicate = (arr1, arr2, uniqueKey = "_id") => {
  return Array.from(
    [...arr1, ...arr2]
      .reduce((m, o) => m.set(o[uniqueKey], o), new Map())
      .values()
  );
};

export const formatHyperlink = (url) => {
  if (url.includes("http://") || url.includes("https://")) {
    return url;
  } else {
    return "http://" + url;
  }
};

export const RGBToHex = (rgb) => {
  if (rgb.indexOf("rgb") === -1) {
    return rgb;
  }
  // Choose correct separator
  let sep = rgb.indexOf(",") > -1 ? "," : " ";
  // Turn "rgb(r,g,b)" into [r,g,b]
  rgb = rgb.substr(4).split(")")[0].split(sep);

  let r = (+rgb[0]).toString(16),
    g = (+rgb[1]).toString(16),
    b = (+rgb[2]).toString(16);

  if (r.length == 1) r = "0" + r;
  if (g.length == 1) g = "0" + g;
  if (b.length == 1) b = "0" + b;

  return "#" + r + g + b;
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const postMessageToSuperScreen = (payload) => {
  const message = {
    dataFromIframe: payload,
  };
  const targetWindow = window.top;
  targetWindow.postMessage(message);
};

export const isVideoOrImage = (url) => {
  // Get the file extension from the URL
  const extension = url.split(".").pop().toLowerCase();

  // List of video extensions (add more if needed)
  const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];

  // List of image extensions (add more if needed)
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];

  // Check if the extension is in the video or image extensions list
  if (videoExtensions.includes(extension)) {
    return "video";
  } else if (imageExtensions.includes(extension)) {
    return "image";
  } else {
    return "unknown";
  }
};

export const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
const IOS_SUPPORTED_MIMETYPE = "video/mp4;codecs=avc1,mp4a";
export const isIosTypeSupported = () =>
  MediaRecorder.isTypeSupported(IOS_SUPPORTED_MIMETYPE);

export const getPlatformInfo = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;

  return {
    userAgent: userAgent,
    platform: platform,
    isMobile: /Mobi|Android/i.test(userAgent),
    isWindows: /Win/i.test(platform),
    isMac: /Mac/i.test(platform),
    isLinux: /Linux/i.test(platform),
    isIOS: /iPhone|iPad|iPod/i.test(userAgent),
    isAndroid: /Android/i.test(userAgent),
    isChrome: /Chrome/i.test(userAgent),
    isFirefox: /Firefox/i.test(userAgent),
    isSafari: /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent),
  };
};

export function extractPoster(srcUrl, blob) {
  return new Promise(function (resolve, reject) {
    if (!srcUrl && !blob) {
      reject("Couldn't find video element or file");
    }
    //const source = (videoElement.src = srcUrl || URL.createObjectURL(blob));
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");

    const ctx = canvas.getContext("2d");

    function initCanvas() {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
    }

    function cleanup() {
      if (video) {
        video.removeEventListener("loadedmetadata", initCanvas);
        video.removeEventListener("timeupdate", drawFrame);
        video.remove();
      }
      if (canvas) {
        canvas.remove();
      }
    }

    function drawFrame(e) {
      video.pause();
      ctx.drawImage(this, 0, 0);
      canvas.toBlob((blob) => {
        cleanup();
        resolve(blob);
      }, "image/jpeg");

      URL.revokeObjectURL(this.src);
    }

    video.addEventListener("loadedmetadata", initCanvas, false);
    video.addEventListener("timeupdate", drawFrame, false);
    video.preload = "metadata";
    video.playsInline = true;
    video.muted = true;
    video.setAttribute("crossOrigin", "anonymous");
    video.style.display = "none";
    canvas.style.display = "none";
    video.src = srcUrl || URL.createObjectURL(blob);
    video.play();
  });
}

export function isValidHttpUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

export const isLandscapeCardOfMasonry = (cardIndex, selectedLayout) => {
  let result = false;
  if (cardIndex === 0 && (selectedLayout === 4 || selectedLayout === 10)) {
    result = true;
  } else if (cardIndex === 2 && selectedLayout === 7) {
    result = true;
  } else if (cardIndex === 3 && selectedLayout === 10) {
    result = true;
  }
  return result;
};

export const formatTimeFromSeonds = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};

export const formatPercentage = (value) => {
  if (Math.floor(value) === value) {
    return value; // return as is if no decimal places
  }

  // Round up to 1 decimal place and return
  const oneDecimalPlace = Math.round(value * 10) / 10;

  if (Math.floor(oneDecimalPlace) === oneDecimalPlace) {
    return oneDecimalPlace;
  }

  // Round up to 2 decimal places and return
  return Math.round(value * 100) / 100;
};

export const getImageBlob = async (imageUrl) => {
  try {
    // Fetch the image
    const response = await fetch(imageUrl);

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.statusText}`);
    }

    // Convert the response to a blob
    const blob = await response.blob();
    console.log("Image blob:", blob);
    return blob;
  } catch (error) {
    console.error("Error fetching image blob:", error);
    throw error; // Re-throw the error for the caller to handle
  }
};

export function stringToColor(str) {
  // Hash the string into a numeric value
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Convert the hash to a hexadecimal color code
  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ("00" + value.toString(16)).slice(-2);
  }

  return color;
}

export const isPastTime = (inputDate) => {
  const targetDate = new Date(inputDate);
  const now = new Date();
  const timeDifference = targetDate - now;
  return timeDifference <= 0;
};

export const isCameraPermissionGranted = async () => {
  try {
    const permissions = await navigator.permissions.query({ name: "camera" });
    return permissions.state === "granted";
  } catch (error) {
    console.error("Permission API error:", error);
    return false; // In case of error, assume permission is not granted.
  }
};
export const scrollToCenter = (parentSelector, childSelector) => {
  const parent = document.querySelector(parentSelector);
  const child = document.querySelector(childSelector);

  if (parent && child) {
    const parentRect = parent.getBoundingClientRect();
    const childRect = child.getBoundingClientRect();

    const scrollLeft =
      childRect.left -
      parentRect.left -
      parentRect.width / 2 +
      childRect.width / 2;
    parent.scrollBy({ left: scrollLeft, behavior: "smooth" });
  }
};

export const isVideoPlaying = (video) =>
  !!(
    video.currentTime > 0 &&
    !video.paused &&
    !video.ended &&
    video.readyState > 2
  );

export const setLastSubmittedTime = (name, time) => {
  // Get the current time in milliseconds
  saveItemToLocalStorage(name, time); // Save the current time as the last submitted time
};

export const getLastSubmittedTime = (name) => {
  const lastSubmittedTime = getItemFromLocalStorage(name); // Retrieve the last submitted time from local storage
  if (lastSubmittedTime) {
    return Number(lastSubmittedTime); // Convert the retrieved time back to a Date object
  }
  return null; // Return null if no last submitted time is found
};

export const reactGridToReactRnd = (reactGridLayout) => {
  return reactGridLayout.lg.map((item) => {
    const position = {
      x: item.x ? item.x * 41 - 14 : 12, // Assuming x is in grid units, convert to pixels
      y: item.y ? item.y * 21 + 12 : 12, // Assuming y is in grid units, convert to pixels
    };
    const size = {
      width: item.w * 40 - 47, // Assuming width is in grid units, convert to pixels
      height: item.h * 19, // Assuming height is in grid units, convert to pixels
    };
    return {
      position,
      size,
    };
  });
};

export const urlToFile = async (url, filename, mimeType) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: mimeType });
};

export const getImageDimensions = (imageUrl) => {
  return new Promise((resolve, reject) => {
    if (!imageUrl) {
      reject(new Error("Image URL is required"));
      return;
    }

    const img = new Image();
    
    img.onload = () => {
      const dimensions = {
        width: img.naturalWidth,
        height: img.naturalHeight
      };
      resolve(dimensions);
    };

    img.onerror = () => {
      reject(new Error("Failed to load image"));
    };

    // Handle both regular URLs and data URLs
    img.src = imageUrl;
  });
};

  export const getEventStatus = (eventInfo) => {
    const currentDate = new Date().getTime();
    const startDate = new Date(eventInfo.startDate).getTime() * 1000;
    const endDate = new Date(eventInfo.endDate) * 1000;
    if (startDate > currentDate) return "Upcoming";
    else if (currentDate < endDate) return "In Progress";
    else return "Completed";
  };
